module.exports = __webpack_public_path__ + "img/logout.6d979442.svg";